window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

    /**
     * For use when focus shifts to a container rather than a link
     * eg for In-page links, after scroll, focus shifts to content area so that
     * next `tab` is where user expects if focusing a link, just $link.focus();
     *
     * @param {JQuery} $element - The element to be acted upon
     */
    pageLinkFocus: function ($element) {
        var focusClass = 'js-focus-hidden';
        $element.first()
            .attr('tabIndex', '-1')
            .focus()
            .addClass(focusClass)
            .one('blur', callback);

        function callback() {
            $element.first()
                .removeClass(focusClass)
                .removeAttr('tabindex');
        }
    },

    /**
     * If there's a hash in the url, focus the appropriate element
     */
    focusHash: function () {
        var hash = window.location.hash;

        // is there a hash in the url? is it an element on the page?
        if (hash && document.getElementById(hash.slice(1))) {
            this.pageLinkFocus($(hash));
        }
    },

    /**
     * When an in-page (url w/hash) link is clicked, focus the appropriate element
     */
    bindInPageLinks: function () {
        $('a[href*=#]').on('click', function (evt) {
            this.pageLinkFocus($(evt.currentTarget.hash));
        }.bind(this));
    },

    /**
     * Traps the focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    trapFocus: function (options) {
        var eventName = options.namespace
            ? 'focusin.' + options.namespace
            : 'focusin';

        if (!options.$elementToFocus) {
            options.$elementToFocus = options.$container;
        }

        options.$container.attr('tabindex', '-1');
        options.$elementToFocus.focus();

        $(document).on(eventName, function (evt) {
            if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
                options.$container.focus();
            }
        });
    },

    /**
     * Removes the trap of focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    removeTrapFocus: function (options) {
        var eventName = options.namespace
            ? 'focusin.' + options.namespace
            : 'focusin';

        if (options.$container && options.$container.length) {
            options.$container.removeAttr('tabindex');
        }

        $(document).off(eventName);
    }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

    /**
     * Browser cookies are required to use the cart. This function checks if
     * cookies are enabled in the browser.
     */
    cookiesEnabled: function () {
        var cookieEnabled = navigator.cookieEnabled;

        if (!cookieEnabled) {
            document.cookie = 'testcookie';
            cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
        }
        return cookieEnabled;
    }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

    /**
     * Return an object from an array of objects that matches the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    findInstance: function (array, key, value) {
        for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return array[i];
            }
        }
    },

    /**
     * Remove an object from an array of objects by matching the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    removeInstance: function (array, key, value) {
        var i = array.length;
        while (i--) {
            if (array[i][key] === value) {
                array.splice(i, 1);
                break;
            }
        }

        return array;
    },

    /**
     * _.compact from lodash
     * Remove empty/false items from array
     * Source: https://github.com/lodash/lodash/blob/master/compact.js
     *
     * @param {array} array
     */
    compact: function (array) {
        var index = -1;
        var length = array == null ? 0 : array.length;
        var resIndex = 0;
        var result = [];

        while (++index < length) {
            var value = array[index];
            if (value) {
                result[resIndex++] = value;
            }
        }
        return result;
    },

    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    defaultTo: function (value, defaultValue) {
        return (value == null || value !== value) ? defaultValue : value
    }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
    /**
     * Wrap tables in a container div to make them scrollable when needed
     *
     * @param {object} options - Options to be used
     * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
     * @param {string} options.tableWrapperClass - table wrapper class name
     */
    wrapTable: function (options) {
        var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

        options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
    },

    /**
     * Wrap iframes in a container div to make them responsive
     *
     * @param {object} options - Options to be used
     * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
     * @param {string} options.iframeWrapperClass - class name used on the wrapping div
     */
    wrapIframe: function (options) {
        var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

        options.$iframes.each(function () {
            // Add wrapper to make video responsive
            $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

            // Re-set the src attribute on each iframe after page load
            // for Chrome's "incorrect iFrame content on 'back'" bug.
            // https://code.google.com/p/chromium/issues/detail?id=395791
            // Need to specifically target video and admin bar
            this.src = this.src;
        });
    }
};

slate.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    $(document)
        .on('shopify:section:load', this._onSectionLoad.bind(this))
        .on('shopify:section:unload', this._onSectionUnload.bind(this))
        .on('shopify:section:select', this._onSelect.bind(this))
        .on('shopify:section:deselect', this._onDeselect.bind(this))
        .on('shopify:section:reorder', this._onReorder.bind(this))
        .on('shopify:block:select', this._onBlockSelect.bind(this))
        .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
    _createInstance: function (container, constructor) {
        var $container = $(container);
        var id = $container.attr('data-section-id');
        var type = $container.attr('data-section-type');

        constructor = constructor || this.constructors[type];

        if (typeof constructor === 'undefined') {
            return;
        }

        var instance = $.extend(new constructor(container), {
            id: id,
            type: type,
            container: container
        });

        this.instances.push(instance);
    },

    _onSectionLoad: function (evt) {
        var container = $('[data-section-id]', evt.target)[0];
        if (container) {
            this._createInstance(container);
        }
    },

    _onSectionUnload: function (evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (!instance) {
            return;
        }

        if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
        }

        this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
    },

    _onSelect: function (evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onSelect === 'function') {
            instance.onSelect(evt);
        }
    },

    _onDeselect: function (evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onDeselect === 'function') {
            instance.onDeselect(evt);
        }
    },

    _onReorder: function (evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onReorder === 'function') {
            instance.onReorder(evt);
        }
    },

    _onBlockSelect: function (evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onBlockSelect === 'function') {
            instance.onBlockSelect(evt);
        }
    },

    _onBlockDeselect: function (evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onBlockDeselect === 'function') {
            instance.onBlockDeselect(evt);
        }
    },

    register: function (type, constructor) {
        this.constructors[type] = constructor;

        $('[data-section-type=' + type + ']').each(function (index, container) {
            this._createInstance(container, constructor);
        }.bind(this));
    }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
    var moneyFormat = '${{amount}}';

    /**
     * Format money values based on your shop currency settings
     * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
     * or 3.00 dollars
     * @param  {String} format - shop money_format setting
     * @return {String} value - formatted value
     */
    function formatMoney(cents, format) {
        if (typeof cents === 'string') {
            cents = cents.replace('.', '');
        }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = (format || moneyFormat);

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = slate.utils.defaultTo(precision, 2);
            thousands = slate.utils.defaultTo(thousands, ',');
            decimal = slate.utils.defaultTo(decimal, '.');

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split('.');
            var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            var centsAmount = parts[1] ? (decimal + parts[1]) : '';

            return dollarsAmount + centsAmount;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_space_separator':
                value = formatWithDelimiters(cents, 2, ' ', '.');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, ',', '.');
                break;
            case 'amount_no_decimals_with_space_separator':
                value = formatWithDelimiters(cents, 0, ' ');
                break;
        }

        return formatString.replace(placeholderRegex, value);
    }

    return {
        formatMoney: formatMoney
    };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {

    /**
     * Preloads an image in memory and uses the browsers cache to store it until needed.
     *
     * @param {Array} images - A list of image urls
     * @param {String} size - A shopify image size attribute
     */

    function preload(images, size) {
        if (typeof images === 'string') {
            images = [images];
        }

        for (var i = 0; i < images.length; i++) {
            var image = images[i];
            this.loadImage(this.getSizedImageUrl(image, size));
        }
    }

    /**
     * Loads and caches an image in the browsers cache.
     * @param {string} path - An image url
     */
    function loadImage(path) {
        new Image().src = path;
    }

    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
        var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

        if (match) {
            return match[1];
        } else {
            return null;
        }
    }

    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
        if (size === null) {
            return src;
        }

        if (size === 'master') {
            return this.removeProtocol(src);
        }

        var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

        if (match) {
            var prefix = src.split(match[0]);
            var suffix = match[0];

            return this.removeProtocol(prefix[0] + '_' + size + suffix);
        } else {
            return null;
        }
    }

    function removeProtocol(path) {
        return path.replace(/http(s)?:/, '');
    }

    return {
        preload: preload,
        loadImage: loadImage,
        imageSize: imageSize,
        getSizedImageUrl: getSizedImageUrl,
        removeProtocol: removeProtocol
    };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {

    /**
     * Variant constructor
     *
     * @param {object} options - Settings from `product.js`
     */
    function Variants(options) {
        this.$container = options.$container;
        this.product = options.product;
        this.singleOptionSelector = options.singleOptionSelector;
        this.originalSelectorId = options.originalSelectorId;
        this.enableHistoryState = options.enableHistoryState;
        this.currentVariant = this._getVariantFromOptions();

        $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    }

    Variants.prototype = $.extend({}, Variants.prototype, {

        /**
         * Get the currently selected options from add-to-cart form. Works with all
         * form input elements.
         *
         * @return {array} options - Values of currently selected variants
         */
        _getCurrentOptions: function () {
            var currentOptions = $.map($(this.singleOptionSelector, this.$container), function (element) {
                var $element = $(element);
                var type = $element.attr('type');
                var currentOption = {};

                if (type === 'radio' || type === 'checkbox') {
                    if ($element[0].checked) {
                        currentOption.value = $element.val();
                        currentOption.index = $element.data('index');

                        return currentOption;
                    } else {
                        return false;
                    }
                } else {
                    currentOption.value = $element.val();
                    currentOption.index = $element.data('index');

                    return currentOption;
                }
            });

            // remove any unchecked input values if using radio buttons or checkboxes
            currentOptions = slate.utils.compact(currentOptions);

            return currentOptions;
        },

        /**
         * Find variant based on selected values.
         *
         * @param  {array} selectedValues - Values of variant inputs
         * @return {object || undefined} found - Variant object from product.variants
         */
        _getVariantFromOptions: function () {
            var selectedValues = this._getCurrentOptions();
            var variants = this.product.variants;
            var found = false;

            variants.forEach(function (variant) {
                var satisfied = true;

                selectedValues.forEach(function (option) {
                    if (satisfied) {
                        satisfied = (option.value === variant[option.index]);
                    }
                });

                if (satisfied) {
                    found = variant;
                }
            });

            return found || null;
        },

        /**
         * Event handler for when a variant input changes.
         */
        _onSelectChange: function () {
            var variant = this._getVariantFromOptions();

            this.$container.trigger({
                type: 'variantChange',
                variant: variant
            });

            if (!variant) {
                return;
            }

            this._updateMasterSelect(variant);
            this._updateImages(variant);
            this._updatePrice(variant);
            this.currentVariant = variant;

            if (this.enableHistoryState) {
                this._updateHistoryState(variant);
            }
        },

        /**
         * Trigger event when variant image changes
         *
         * @param  {object} variant - Currently selected variant
         * @return {event}  variantImageChange
         */
        _updateImages: function (variant) {
            var variantImage = variant.featured_image || {};
            var currentVariantImage = this.currentVariant.featured_image || {};

            if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
                return;
            }

            this.$container.trigger({
                type: 'variantImageChange',
                variant: variant
            });
        },

        /**
         * Trigger event when variant price changes.
         *
         * @param  {object} variant - Currently selected variant
         * @return {event} variantPriceChange
         */
        _updatePrice: function (variant) {
            if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
                return;
            }

            this.$container.trigger({
                type: 'variantPriceChange',
                variant: variant
            });
        },

        /**
         * Update history state for product deeplinking
         *
         * @param {object} variant - Currently selected variant
         */
        _updateHistoryState: function (variant) {
            if (!history.replaceState || !variant) {
                return;
            }

            var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
            window.history.replaceState({path: newurl}, '', newurl);
        },

        /**
         * Update hidden master select of variant change
         *
         * @param {object} variant - Currently selected variant
         */
        _updateMasterSelect: function (variant) {
            $(this.originalSelectorId, this.$container)[0].value = variant.id;
        }
    });

    return Variants;
})();


/*================ Modules ================*/
/**
 * Account Nav Dropdown
 * ------------------------------------------------------------------------------
 * @namespace accountNav
 */

theme.accountNav = (function () {
    if (document.getElementById('MobileAccountNav') === null) {
        return;
    }

    var namespace = '.accountNav';

    var cache = {
        $accountNavHeader: $('[data-account-nav-toggle]')
    };

    cache.$accountNavHeader.on('click' + namespace, toggleDropDown);

    function toggleDropDown(evt) {
        var $el = $(evt.currentTarget);
        var $parent = $el.closest('.account-nav');

        $parent.toggleClass('is-open');
    }
})();

/**
 * Stick element to page when page is scrolled
 * @constructor
 * @param {strig} el - DOM selector string to set as sticky
 */
theme.StickyElement = (function () {
    function StickyElement(el, offset = 0) {
        var $el = this.$el = $(el);
        var $body = $('body');
        var namespace = '.stickyElement';
        var elemPosition = $el.offset().top;
        var elemHeight = $el.outerHeight(true);

        $el.addClass('sticky-element');

        $(window).on('scroll', toggleElementState).scroll();

        function toggleElementState() {
            var pagePosition = $(window).scrollTop();
            elemPosition = $el.offset().top;
            // Toggle sticky class
            pagePosition + offset >= elemPosition
                ? ($el.addClass('is-sticky'), $el.parent().css({paddingTop: elemHeight + offset}))
                : ($el.removeClass('is-sticky'), $el.parent().css({paddingTop: 0}));
        }
    }

    return StickyElement;
})();

/**
 * Header
 * ------------------------------------------------------------------------------
 * @namespace header
 */

theme.header = (function () {

    var selectors = {
        search: '.search',
        searchSubmit: '.search__submit',
        searchInput: '.search__input',
        siteHeader: '.site-header',
        siteHeaderSearchToggle: '.site-header__search-toggle',
        siteHeaderSearch: '.site-header__search',
        searchDrawer: '.search-bar',
        searchDrawerInput: '.search-bar__input',
        searchHeader: '.search-header',
        searchHeaderInput: '.search-header__input',
        searchHeaderSubmit: '.search-header__submit',
    };

    var cache = {
        $promoClose: $('.promo-close'),
        $promoBar: $('.promo-bar'),
        $header: $('#shopify-section-header'),
        $dropdownLink: $('.site-nav--has-submenu'),
        $mobileDropdown: $('.mobile-nav__trigger')
    };

    var classes = {
        focus: 'search--focus',
        mobileNavIsOpen: 'js-menu--is-open'
    };

    // determine if we should show promo bar on page load
    if (cache.$promoBar.length && !getPromoSessionStoage()) {
        cache.$promoBar.removeClass('promo-bar--hidden');
    }

    // Event Handlers
    searchSubmit();

    cache.$promoClose.on('click', closePromoBar);
    cache.$dropdownLink.on('mouseenter', megaMenuHandle);
    cache.$mobileDropdown.on('click', triggerMobileDropdown);

    $(selectors.searchHeaderInput).add(selectors.searchHeaderSubmit).on('focus blur', function () {
        $(selectors.searchHeader).toggleClass(classes.focus);
    });
    $(selectors.siteHeaderSearchToggle).on('click', function () {
        var searchHeight = $(selectors.siteHeader).outerHeight();
        var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;
        $(selectors.searchDrawer).css({
            height: searchHeight + 'px',
            top: searchOffset + 'px'
        });
    });

    function triggerMobileDropdown(evt) {
        var $el = $(evt.currentTarget);
        var $parent = $el.parent();

        evt.preventDefault();

        if ($parent.hasClass('active')) {
            $parent.removeClass('active');
        } else {
            $parent.addClass('active');
        }
    }

    function closePromoBar() {
        cache.$promoBar.addClass('promo-bar--hidden');

        // set session storage
        sessionStorage.setItem('promoBarHidden', true);
    }

    function megaMenuHandle(evt) {
        var $el = $(evt.currentTarget);
        var headerHeight = cache.$header.innerHeight();
        var $mega = $el.children('.site-nav__submenu--children-list');

        $el.addClass('active');
        //$mega.css('top', headerHeight);
    }

    function getPromoSessionStoage() {
        return sessionStorage.getItem('promoBarHidden');
    }

    function searchSubmit() {
        $(selectors.searchSubmit).on('click', function (evt) {
            var $el = $(evt.target);
            var $input = $el.parents(selectors.search).find(selectors.searchInput);
            if ($input.val().length === 0) {
                evt.preventDefault();
                searchFocus($input);
            }
        });
    }

    function adjustHeader() {

    }

    window.addEventListener('scroll', function (e) {
        if ($('.top-spacer').offset().top < window.pageYOffset) {
            $('body').addClass('scrolled');

        } else {
            $('body').removeClass('scrolled');

        }

    })
})();


/*================ Global ================*/
/*============================================================================
  Handleize
==============================================================================*/
theme.handleize = function (str) {
    return str
        .toLowerCase()
        .replace(/[^\w\u00C0-\u024f]+/g, "-")
        .replace(/^-+|-+$/g, "");
};

/*============================================================================
  Atrribute to String
==============================================================================*/
theme.attributeToString = function (attribute) {
    if (typeof attribute !== "string") {
        attribute += "";
        if (attribute === "undefined") {
            attribute = "";
        }
    }
    return jQuery.trim(attribute);
};

/*============================================================================
  Thenable delay
==============================================================================*/
theme.delay = function (ms, data) {
    // delay a jquery deferred object
    var deferred = jQuery.Deferred();

    setTimeout(function () {
        if (!data) {
            deferred.resolve();
        } else {
            deferred.resolve(data);
        }
    }, ms);

    return deferred.promise();
};

/*============================================================================
  Fake promisify using jQuery.deferred
==============================================================================*/
theme.promisify = function (value) {
    var deferred = jQuery.Deferred();
    return deferred.resolve(value).promise();
};

/*============================================================================
  Get Session Storage
==============================================================================*/
/**
 * Grab data from session storage
 *
 * @param {string} key - Data key to grab data
 */
theme.getSessionItem = function (key) {
    var item = sessionStorage.getItem(key);

    return JSON.parse(item);
}

/**
 * Save data into session storage
 *
 * @param {string} key - Data key
 * @param {object} val - item to save
 */
theme.setSessionItem = function (key, val) {
    if (typeof key !== 'string') {
        return;

        if (key === 'undefined' && val === 'undefined') {
            return;
        }
    }

    sessionStorage.setItem(key, JSON.stringify(val));
}

/**
 * Remove data from session storage
 *
 * @param {string} key - Data key to delete data
 */
theme.removeSessionItem = function (key) {
    return sessionStorage.removeItem(key);
}

/**
 * Global Configurations
 * ------------------------------------------------------------------------------
 */
theme.config = {
    // Media queries & breakpoints based on src/styles/tools/variables.scss.liquid
    mediaQueries: {
        xs: 'screen and (max-width: 29.99em)',
        smallDown: 'screen and (max-width: 47.99em)',
        small: 'screen and (min-width: 30em) and (max-width: 47.99em)',
        smallUp: 'screen and (min-width: 30em)',
        mediumDown: 'screen and (max-width: 63.99em)',
        medium: 'screen and (min-width: 48em) and (max-width: 63.99em)',
        mediumUp: 'screen and (min-width: 48em)'
    },
    breakpoints: {
        small: 480,
        medium: 768,
        large: 1024,
        widescreen: 1280
    }
};

if ((typeof ShopifyAPI) === 'undefined') {
    ShopifyAPI = {};
}

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function (cart) {
    // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function (note, callback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'note=' + theme.attributeToString(note),
            dataType: 'json',
            beforeSend: function () {
                $body.trigger('beforeUpdateCartNote.ajaxCart', note);
            },
            success: function (cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                } else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
            },
            error: function (XMLHttpRequest, textStatus) {
                $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function (jqxhr, text) {
                $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        alert(data.message + '(' + data.status + '): ' + data.description);
    }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of data object
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItem = function (data, callback, errorCallback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            beforeSend: function (jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart', data);
            },
            success: function (line_item) {
                if ((typeof callback) === 'function') {
                    callback(line_item, data);
                } else {
                    ShopifyAPI.onItemAdded(line_item, data);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item, data]);
            },
            error: function (XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                } else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function (jqxhr, text) {
                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

ShopifyAPI.addItems = function (items, callback, errorCallback) {
    var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: {
            items: items
        },
        dataType: 'json',
        success: function (line_item) {

            if ((typeof callback) === 'function') {
                callback(line_item);
            } else {
                window.ajaxCart.itemAddedCallback(line_item);
            }
        },
        error: function (XMLHttpRequest, textStatus) {
            if ((typeof errorCallback) === 'function') {
                errorCallback(XMLHttpRequest, textStatus);
            } else {
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            }
        }
    };
    jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function (callback) {
    $(document.body).trigger('beforeGetCart.ajaxCart');
    jQuery.getJSON('/cart.js', function (cart, textStatus) {
        window.cart = cart;
        if ((typeof callback) === 'function') {
            callback(cart);
        } else {
            ShopifyAPI.onCartUpdate(cart);
        }
        $(document.body).trigger('afterGetCart.ajaxCart', cart);
    });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function (line, quantity, callback) {
    if (!window.cart && cart_data) {
        window.cart = cart_data;
    }


    var changing = window.cart.items[line - 1];
    var key = changing.key;
    var oldQty = changing.quantity;
    var packNo = parseInt(changing.properties["Pack #"]);

    var updates = window.cart.items.map(i => {
        if (i.key == key) {
            return quantity;
        } else if (i.properties['Pack #'] == packNo) {
            return i.quantity / oldQty * quantity;
        } else {
            return i.quantity;
        }
    })

    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/update.js',
            data: {
                updates: updates
            },
            dataType: 'json',
            beforeSend: function () {
                $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
            },
            success: function (cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                } else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
            },
            error: function (XMLHttpRequest, textStatus) {
                $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function (jqxhr, text) {
                $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
            }
        };

    // {
    //   type: 'POST',
    //   url: '/cart/change.js',
    //   data: 'quantity=' + quantity + '&line=' + line,
    //   dataType: 'json',
    //   beforeSend: function() {
    //     $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    //   },
    //   success: function(cart) {
    //     if ((typeof callback) === 'function') {
    //       callback(cart);
    //     } else {
    //       ShopifyAPI.onCartUpdate(cart);
    //     }
    //     $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    //   },
    //   error: function(XMLHttpRequest, textStatus) {
    //     $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
    //     ShopifyAPI.onError(XMLHttpRequest, textStatus);
    //   },
    //   complete: function(jqxhr, text) {
    //     $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    //   }
    // };
    return jQuery.ajax(params);
};

/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function () {
    function Drawer(id, position, options) {
        var defaults = {
            close: '.js-drawer-close',
            open: '.js-drawer-open-' + position,
            openClass: 'js-drawer-open',
            dirOpenClass: 'js-drawer-open-' + position
        };

        this.nodes = {
            $parent: $('html').add('body'),
            $page: $('#PageContainer')
        };

        this.config = $.extend(defaults, options);
        this.position = position;

        this.$drawer = $('#' + id);

        if (!this.$drawer.length) {
            return false;
        }

        this.drawerIsOpen = false;
        this.init();
    }

    Drawer.prototype.init = function () {
        $(this.config.open).on('click', $.proxy(this.open, this));
        this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
    };

    Drawer.prototype.open = function (evt) {
        // Keep track if drawer was opened from a click, or called by another function
        var externalCall = false;

        // Prevent following href if link is clicked
        if (evt) {
            evt.preventDefault();
        } else {
            externalCall = true;
        }

        // Without this, the drawer opens, the click event bubbles up to nodes.$page
        // which closes the drawer.
        if (evt && evt.stopPropagation) {
            evt.stopPropagation();
            // save the source of the click, we'll focus to this on close
            this.$activeSource = $(evt.currentTarget);
        }

        if (this.drawerIsOpen && !externalCall) {
            return this.close();
        }

        // Add is-transitioning class to moved elements on open so drawer can have
        // transition for close animation
        this.$drawer.prepareTransition();

        this.nodes.$parent.addClass(
            this.config.openClass + ' ' + this.config.dirOpenClass
        );
        this.drawerIsOpen = true;

        // Set focus on drawer
        slate.a11y.trapFocus({
            $container: this.$drawer,
            namespace: 'drawer_focus'
        });

        // Run function when draw opens if set
        if (
            this.config.onDrawerOpen &&
            typeof this.config.onDrawerOpen === 'function'
        ) {
            if (!externalCall) {
                this.config.onDrawerOpen();
            }
        }

        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
            this.$activeSource.attr('aria-expanded', 'true');
        }

        this.bindEvents();

        return this;
    };

    Drawer.prototype.close = function () {
        if (!this.drawerIsOpen) {
            // don't close a closed drawer
            return;
        }

        // deselect any focused form elements
        $(document.activeElement).trigger('blur');

        // Ensure closing transition is applied to moved elements, like the nav
        this.$drawer.prepareTransition();

        this.nodes.$parent.removeClass(
            this.config.dirOpenClass + ' ' + this.config.openClass
        );

        this.drawerIsOpen = false;

        // Remove focus on drawer
        slate.a11y.removeTrapFocus({
            $container: this.$drawer,
            namespace: 'drawer_focus'
        });

        this.unbindEvents();
    };

    Drawer.prototype.bindEvents = function () {
        this.nodes.$parent.on(
            'keyup.drawer',
            $.proxy(function (evt) {
                // close on 'esc' keypress
                if (evt.keyCode === 27) {
                    this.close();
                    return false;
                } else {
                    return true;
                }
            }, this)
        );

        // Lock scrolling on mobile
        this.nodes.$page.on('touchmove.drawer', function () {
            return false;
        });

        this.nodes.$page.on(
            'click.drawer',
            $.proxy(function () {
                this.close();
                return false;
            }, this)
        );
    };

    Drawer.prototype.unbindEvents = function () {
        this.nodes.$page.off('.drawer');
        this.nodes.$parent.off('.drawer');
    };

    return Drawer;
})();

/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid
==============================================================================*/

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function (module, $) {
    'use strict';
    /*global ShopifyAPI, slate, theme, Handlebars, Shopify */

    // Private general variables
    var settings, isUpdating, $body;

    // Private plugin variables
    var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer;

    /*============================================================================
    PUBLIC METHODS - Initialise the plugin and define global options
  ==============================================================================*/
    function init(options) {

        // Default settings
        settings = {
            formSelector: 'form[action^="/cart/add"]',
            cartContainer: '#CartContainer',
            addToCartSelector: 'input[type="submit"]',
            cartCountSelector: null,
            cartCostSelector: null,
            moneyFormat: '${{amount}}',
            disableAjaxCart: false,
            enableQtySelectors: true
        };

        // Override defaults with arguments
        $.extend(settings, options);

        // Select DOM elements
        $formContainer = $(settings.formSelector);
        $cartContainer = $(settings.cartContainer);
        $addToCart = $formContainer.find(settings.addToCartSelector);

        $cartCountSelector = $(settings.cartCountSelector);
        $cartCostSelector = $(settings.cartCostSelector);

        // General Selectors
        $body = $(document.body);

        // Track cart activity status
        isUpdating = false;

        // Setup ajax quantity selectors on the any template if enableQtySelectors is true
        if (settings.enableQtySelectors) {
            _qtySelectors();
        }

        // Take over the add to cart form submit action if ajax enabled
        if (!settings.disableAjaxCart && $addToCart.length) {
            _formOverride();
        }

        // Run this function in case we're using the quantity selector outside of the cart
        _adjustCart();
        this.addItemCallback = _itemAddedCallback;
        this.cartUpdateCallback = _cartUpdateCallback;
    }

    function loadCart() {

        $body.addClass('drawer--is-loading');
        ShopifyAPI.getCart(_cartUpdateCallback);
    }

    /*============================================================================
    PRIVATE METHODS
  ==============================================================================*/
    function _updateCountPrice(cart) {
        if ($cartCountSelector) {

            var itemcnt = cart.items.reduce((memo, i) => {
                if (!i.properties || !i.properties["_parent"]) {
                    return memo + i.quantity;
                }
                return memo
            }, 0);

            $cartCountSelector.html(itemcnt).toggle(cart.item_count > 0);


        }
        if ($cartCostSelector) {
            $cartCostSelector.html(slate.Currency.formatMoney(cart.total_price, settings.moneyFormat));
        }
    }

    function _formOverride() {
        $formContainer.on('submit', function (evt) {
            evt.preventDefault();

            // GA4 add_to_cart
            try {
                let quantity = document.querySelector("#Quantity") ? parseInt(document.querySelector("#Quantity").value) : 1;
                dataLayer.push({ecommerce: null});
                dataLayer.push({
                    event: 'add_to_cart',
                    ecommerce: {
                        subscription_included: false,
                        value: activeVariant.price * quantity / 100,
                        currency: Shopify.currency.active,
                        items: [{
                            item_id: product.id,
                            item_name: product.title,
                            item_variant: activeVariant.title,
                            price: activeVariant.price / 100,
                            quantity: quantity,
                            subscription_item: false,
                        }]
                    }
                });
            } catch (e) {
                // do nothing
            }

            // Add class to be styled if desired
            $addToCart.removeClass('is-added').addClass('is-adding');

            // Remove any previous quantity errors
            $('.qty-error').remove();

            ShopifyAPI.addItem($(evt.target).serialize(), _itemAddedCallback, _itemErrorCallback);
        });
    }

    function _itemAddedCallback() {
        $addToCart.removeClass('is-adding').addClass('is-added');

        ShopifyAPI.getCart(_cartUpdateCallback);
    }

    function _itemErrorCallback(XMLHttpRequest, textStatus) {
        var data = JSON.parse(XMLHttpRequest.responseText);
        $addToCart.removeClass('is-adding is-added');

        if (!!data.message) {
            if (data.status === 422) {
                $formContainer.after('<div class="errors qty-error">' + data.description + '</div>');
                console.log(data, textStatus);
            }
        }
    }

    function _cartUpdateCallback(cart) {
        // Update quantity and price
        _updateCountPrice(cart);
        _buildCart(cart);
    }

    function _buildCart(cart) {
        // Start with a fresh cart div
        $cartContainer.empty();

        // Show empty cart
        if (cart.item_count === 0) {
            $cartContainer
                .append('<p>' + theme.strings.emptyCart + '</p>');
            _cartCallback(cart);
            return;
        }

        // Handlebars.js cart layout
        var items = [],
            item = {},
            data = {},
            source = $("#CartTemplate").html(),
            template = Handlebars.compile(source);

        var qtyBlacklist = [4289399947369];

        // Add each item to our handlebars.js data
        $.each(cart.items, function (index, cartItem) {

            /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */
            if (cartItem.image != null) {
                var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
            } else {
                var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
            }

            // Hide ShipScout property
            if (cartItem.properties) {
                delete cartItem.properties['_sc']
            }

            // Hide Recharge subscription properties
            var filteredProperties = [];
            if (cartItem.properties) {
                var propertiesArray = Object.entries(cartItem.properties)
                filteredProperties = propertiesArray.filter(function (property) {
                    return !property[0].includes('subscription') && !property[0].includes('interval') && !property[0].startsWith('_') && !property[0].includes('Flavor-') && !property[0].includes('Pack #') && !property[0].includes('Address');
                });
            }

            // Check if product id is the blacklist
            var isQtyBlacklist = qtyBlacklist.filter(function (id) {
                return id === cartItem.product_id;
            }).length > 0;

            var packNo = cartItem.properties["Pack #"];
            if (packNo && cartItem.sku.startsWith('IC-PIK')) {
                var sub_items = cart.items.filter(i => i.properties && i.properties['Pack #'] == packNo && !i.sku.startsWith('IC-PIK')).map(i => {
                    return {
                        title: i.title,
                        quantity: i.quantity,
                        image: i.image ? i.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '') : null
                    }
                });
            } else if (packNo) {
                return null;
            }


            // Create item's data object and add to 'items' array
            item = {
                key: cartItem.key,
                line: index + 1, // Shopify uses a 1+ index in the API
                url: cartItem.url,
                img: prodImg,
                sub_items: sub_items,
                name: cartItem.sku.startsWith('IC-PIK') ? `${cartItem.product_title} (${cartItem.variant_title} pack)` : cartItem.product_title,
                variation: cartItem.sku.startsWith('IC-PIK') ? null : cartItem.variant_title,
                properties: filteredProperties.length !== 0 ? cartItem.properties : false,
                itemAdd: cartItem.quantity + 1,
                itemMinus: cartItem.quantity - 1,
                itemQty: cartItem.quantity,
                price: slate.Currency.formatMoney(cartItem.price, settings.moneyFormat),
                vendor: cartItem.vendor,
                linePrice: slate.Currency.formatMoney(cartItem.line_price, settings.moneyFormat),
                originalLinePrice: slate.Currency.formatMoney(cartItem.original_line_price, settings.moneyFormat),
                discounts: cartItem.discounts,
                discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
                hideQty: isQtyBlacklist,
                plan: false
            };

            // add selling plan
            if (cartItem.selling_plan_allocation) {
                item.plan = cartItem.selling_plan_allocation.selling_plan.name.split(",")[0];
            }

            items.push(item);
        });

        // Gather all cart data and add to DOM
        data = {
            items: items,
            note: cart.note,
            totalPrice: slate.Currency.formatMoney(cart.total_price, settings.moneyFormat),
            totalCartDiscount: cart.total_discount === 0 ? 0 : theme.strings.cartSavings + ' ' + slate.Currency.formatMoney(cart.total_discount, settings.moneyFormat),
            totalCartDiscountApplied: cart.total_discount === 0 ? false : true
        };

        $cartContainer.append(template(data));


        // GA4 view_cart
        dataLayer.push({ecommerce: null});
        dataLayer.push({
            event: "view_cart",
            ecommerce: {
                subscription_included: cart.items.filter(item => item.selling_plan_allocation).length > 0,
                currency: Shopify.currency.active,
                value: cart.total_price / 100,
                items: cart.items.map(function (item) {
                    return {
                        item_id: item.product_id,
                        item_name: item.product_title,
                        item_variant: item.variant_title,
                        price: item.price / 100,
                        quantity: item.quantity,
                        subscription_item: item.selling_plan_allocation !== undefined
                    }
                })
            }
        });


        //update cart note or attributes (_ for attributes are hidden and __ are private)
        //let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
        function updateCart(formData) {
            return fetch('/cart/update.js', {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
                .then(function (data) {
                    return data.json();
                })
        }

        // submit
        document.querySelector(".submitCart").addEventListener("click", async function (e) {
            e.preventDefault();

            // GA4 begin_checkout
            dataLayer.push({ecommerce: null});
            dataLayer.push({
                event: 'begin_checkout',
                ecommerce: {
                    subscription_included: cart.items.filter(item => item.selling_plan_allocation).length > 0,
                    currency: Shopify.currency.active,
                    value: cart.total_price / 100,
                    items: cart.items.map(function (item) {
                        return {
                            item_id: item.product_id,
                            item_name: item.product_title,
                            item_variant: item.variant_title,
                            price: item.price / 100,
                            quantity: item.quantity,
                            subscription_item: item.selling_plan_allocation !== undefined
                        }
                    })
                }
            });

            // update cart note
            this.classList.add("loading");

            await updateCart({note: document.querySelector(".cartNoteInput").value});

            window.location.href = "/checkout";

            this.classList.remove("loading");
        });

        _cartCallback(cart);


        window.itemAdded = _itemAddedCallback;
    }

    function _cartCallback(cart) {
        $body.removeClass('drawer--is-loading');
        $body.trigger('afterCartLoad.ajaxCart', cart);

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
            Shopify.StorefrontExpressButtons.initialize();
        }
    }

    function _adjustCart() {
        // Delegate all events because elements reload with the cart

        // Add or remove from the quantity
        $body.on('click', '.ajaxcart__qty-adjust', function () {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                $qtySelector = $el.siblings('.ajaxcart__qty-num'),
                qty = parseInt($qtySelector.val().replace(/\D/g, ''));

            var qty = _validateQty(qty);

            // Add or subtract from the current quantity
            if ($el.hasClass('ajaxcart__qty--plus')) {
                qty += 1;
            } else {
                qty -= 1;
                if (qty <= 0) qty = 0;
            }

            // If it has a data-line, update the cart.
            // Otherwise, just update the input's number
            if (line) {
                updateQuantity(line, qty);
            } else {
                $qtySelector.val(qty);
            }
        });

        // Update quantity based on input on change
        $body.on('change', '.ajaxcart__qty-num', function () {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                qty = parseInt($el.val().replace(/\D/g, ''));

            var qty = _validateQty(qty);

            // If it has a data-line, update the cart
            if (line) {
                updateQuantity(line, qty);
            }
        });

        // Prevent cart from being submitted while quantities are changing
        $body.on('submit', 'form.ajaxcart', function (evt) {
            if (isUpdating) {
                evt.preventDefault();
            }
        });

        // Highlight the text when focused
        $body.on('focus', '.ajaxcart__qty-adjust', function () {
            var $el = $(this);
            setTimeout(function () {
                $el.select();
            }, 50);
        });

        function updateQuantity(line, qty) {
            isUpdating = true;

            // Add activity classes when changing cart quantities
            var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

            if (qty === 0) {
                $row.parent().addClass('is-removed');

                setTimeout(function () {
                    checkForOnlyUpsells();
                }, 1000);
            }

            // Slight delay to make sure removed animation is done
            setTimeout(function () {
                ShopifyAPI.changeItem(line, qty, _adjustCartCallback);
            }, 250);

        }

        // Save note anytime it's changed
        $body.on('change', 'textarea[name="note"]', function () {
            var newNote = $(this).val();

            // Update the cart note in case they don't click update/checkout
            ShopifyAPI.updateCartNote(newNote, function (cart) {
            });
        });
    }

    function _adjustCartCallback(cart) {
        // Update quantity and price
        _updateCountPrice(cart);

        // Reprint cart on short timeout so you don't see the content being removed
        setTimeout(function () {
            isUpdating = false;
            ShopifyAPI.getCart(_buildCart);
        }, 150);
    }

    function _qtySelectors() {
        // Change number inputs to JS ones, similar to ajax cart but without API integration.
        // Make sure to add the existing name and id to the new input element
        var numInputs = $('input[type="number"]');

        if (numInputs.length) {
            numInputs.each(function () {
                var $el = $(this),
                    currentQty = $el.val(),
                    inputName = $el.attr('name'),
                    inputId = $el.attr('id');

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#JsQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus,
                        inputName: inputName,
                        inputId: inputId,
                        handle: $el.data('product-handle') ? $el.data('product-handle') : null,
                        readonly: $el.attr('readonly') ? true : false
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });

            // Setup listeners to add/subtract from the input
            $('.js-qty__adjust').on('click', function () {
                var $el = $(this),
                    id = $el.data('id'),
                    $qtySelector = $el.siblings('.js-qty__num'),
                    qty = parseInt($qtySelector.val().replace(/\D/g, ''));

                var qty = _validateQty(qty);

                // Add or subtract from the current quantity
                if ($el.hasClass('js-qty__adjust--plus')) {
                    qty += 1;
                } else {
                    qty -= 1;
                    if (qty <= 1) qty = 1;
                }

                // Update the input's number
                $qtySelector.val(qty);
                // Trigger a change event when value changes
                $qtySelector.trigger('change');
            });
        }
    }

    function _validateQty(qty) {
        if ((parseFloat(qty) === parseInt(qty)) && !isNaN(qty)) {
            // We have a valid number!
        } else {
            // Not a number. Default to 1.
            qty = 1;
        }
        return qty;
    }

    module = {
        init: init,
        load: loadCart
    };

    return module;

}(ajaxCart || {}, jQuery));

window.theme = window.theme || {};

theme.CartDrawer = new theme.Drawers('CartDrawer', 'right', {
    onDrawerOpen: ajaxCart.load
});

// Init ajax cart
ajaxCart.init({
    formSelector: '[data-product-form]',
    cartContainer: '#CartContainer',
    addToCartSelector: '[data-add-to-cart]',
    cartCountSelector: '[data-cart-count]',
    moneyFormat: theme.moneyFormat
});
// Bind to 'afterCartLoad.ajaxCart' to run any javascript after the cart has loaded in the DOM
jQuery(document.body).on('afterCartLoad.ajaxCart', function (evt, cart) {
    theme.CartDrawer.open();
});

/**
 * Mobile Navigation Script
 * ------------------------------------------------------------------------------
 */

theme.MobileNav = (function () {
    var selectors = {
        mobileNavDrawer: '#MobileNavDrawer'
    };
    var cache = {};

    function init() {
        cacheSelectors();
        initDrawer();
    }

    function cacheSelectors() {
        cache = {
            mobileNavDrawer: $(selectors.mobileNavDrawer)
        };
    }

    function initDrawer() {
        // Add required classes to HTML
        $('#PageContainer').addClass('drawer-page-content');
        $('.js-drawer-open-left')
            .attr('aria-controls', 'MobileNavDrawer')
            .attr('aria-expanded', 'false');

        theme.MobileNavDrawer = new theme.Drawers('MobileNavDrawer', 'left');
    }

    return {
        init: init
    };
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function () {

    var selectors = {
        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
        comparePrice: '[data-compare-price]',
        comparePriceText: '[data-compare-text]',
        originalSelectorId: '[data-product-select]',
        priceWrapper: '[data-price-wrapper]',
        productPhotos: '[data-product-photos]',
        productPhoto: '[data-product-photo]',
        productJson: '[data-product-json]',
        productPrice: '[data-product-price]',
        productThumbs: '[data-product-single-thumbnail]',
        singleOptionSelector: '[data-single-option-selector]',
        rechargeSelectContainer: '#rc_container',
        rechargeSelectedOption: 'input[name="purchase_type"]:checked',
        rechargeOnetimePrice: '#rc_price_onetime',
        rechargeAutodeliverPrice: '#rc_price_autodeliver',
    };

    /**
     * Product section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function Product(container) {
        this.$container = $(container);

        // Stop parsing if we don't have the product json script tag when loading
        // section in the Theme Editor
        if (!$(selectors.productJson, this.$container).html()) {
            return;
        }

        var sectionId = this.$container.attr('data-section-id');
        this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

        var options = {
            $container: this.$container,
            enableHistoryState: this.$container.data('enable-history-state') || false,
            singleOptionSelector: selectors.singleOptionSelector,
            originalSelectorId: selectors.originalSelectorId,
            product: this.productSingleObject
        };

        this.settings = {};
        this.namespace = '.product';
        this.variants = new slate.Variants(options);

        // Selectors
        this.$productPhotos = $(selectors.productPhotos, this.$container);
        this.$productThumbs = $(selectors.productThumbs, this.$container);

        // Events
        this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
        this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
        this.$productThumbs.on('click' + this.namespace, this.updateProductImage.bind(this));
        this.$container.on('change' + this.namespace, selectors.rechargeSelectContainer, this.handleRechargeChange.bind(this));


        // Run on pageload
        if (this.$productThumbs.length) {
            this.initPhotosSlider();
        }

        // Listen for recharge mutations
        if ($(selectors.rechargeSelectContainer).length) {
            this.rechargeMutationListener.bind(this);
            this.rechargeMutationListener();
        }
    }

    Product.prototype = $.extend({}, Product.prototype, {

        /**
         * Updates the DOM state of the add to cart button
         *
         * @param {boolean} enabled - Decides whether cart is enabled or disabled
         * @param {string} text - Updates the text notification content of the cart
         */
        updateAddToCartState: function (evt) {
            var variant = evt.variant;

            if (variant) {
                $(selectors.priceWrapper, this.$container).removeClass('hide');
            } else {
                $(selectors.addToCart, this.$container).prop('disabled', true);
                $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
                $(selectors.priceWrapper, this.$container).addClass('hide');
                return;
            }

            if (variant.available) {
                $(selectors.addToCart, this.$container).prop('disabled', false);
                $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
            } else {
                $(selectors.addToCart, this.$container).prop('disabled', true);
                $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
            }
        },

        /**
         * Updates the DOM with specified prices
         *
         * @param {string} productPrice - The current price of the product
         * @param {string} comparePrice - The original price of the product
         */
        updateProductPrices: function (evt) {
            var variant = evt.variant;
            var $comparePrice = $(selectors.comparePrice, this.$container);
            var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

            $(selectors.productPrice, this.$container)
                .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

            if (variant.compare_at_price > variant.price) {
                $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
                $compareEls.removeClass('hide');
            } else {
                $comparePrice.html('');
                $compareEls.addClass('hide');
            }
        },

        /**
         * Updates the DOM with the specified image URL
         *
         * @param {string} src - Image src URL
         */
        updateProductImage: function (evt) {
            evt.preventDefault();
            var $el = $(evt.currentTarget);
            var imageId = $el.data('image-id');
            var $newImage = $(selectors.productPhoto + '[data-image-id="' + imageId + '"]');

            if ($newImage.length) {
                this.$productPhotos.slick('slickGoTo', $newImage.data('slick-index'));
            }
        },

        /**
         * Initialize photos slider with slick
         */
        initPhotosSlider: function () {
            var options = {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                arrows: false,
                responsive: [
                    {
                        breakpoint: theme.config.breakpoints.medium,
                        settings: {
                            dots: true
                        }
                    }
                ]
            };

            this.$productPhotos.slick(options);
        },


        /**
         * Update the price based for recharge products
         * This price is NOT based on variants
         * @param {boolean} isAutodeliver - Set to true if auto-delivery is selected
         */
        updateRechargePrice: function (isAutodeliver) {
            var price = isAutodeliver ? $(selectors.rechargeAutodeliverPrice).text() : $(selectors.rechargeOnetimePrice).text();

            if (price.length) {
                $(selectors.productPrice, this.$container).html(price);
            }
        },

        /**
         * This gets triggered when a customer switches between
         * auto-delivery and one-time purchase
         */
        handleRechargeChange: function () {
            var isAutodeliver = $(selectors.rechargeSelectedOption).val() === ('autodeliver');
            this.updateRechargePrice(isAutodeliver);
        },

        /**
         * Once recharge injects its content (aka mutation observed), update the price
         */
        rechargeMutationListener: function () {
            var self = this;
            var targetNode = document.getElementById('rc_container');
            var config = {attributes: true, childList: true, subtree: true};
            var callback = function (mutationsList, observer) {
                self.handleRechargeChange();
                observer.disconnect();
            };
            var observer = new MutationObserver(callback);

            observer.observe(targetNode, config);
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function () {
            this.$container.off(this.namespace);
        }
    });

    return Product;
})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.ProductPintSelect = (function () {

    var selectors = {
        pintsBundleProductJson: '[data-pints-bundle-product-json]',
        addToCart: '[data-add-to-cart]',
        resetPack: '[data-reset-pack]',
    };


    /**
     * ProductPintSelect section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function ProductPintSelect(container) {
        this.$container = $(container);

        // Extend theme.Product constructor
        theme.Product.call(this, container);

        // settings
        this.pintsBundleProductJson = JSON.parse($(selectors.pintsBundleProductJson, this.$container).html());
        this.state = {
            queue: theme.getSessionItem('pintsSelected')
        };

        // Selectors
        this.$addToCart = $(selectors.addToCart, this.$container);
        this.$resetPack = $(selectors.resetPack, this.$container);

        // Events
        this.$addToCart.on('click', this.onAddToCartClick.bind(this));
        this.$resetPack.on('click', this.onResetPack.bind(this));
    }

    ProductPintSelect.prototype = $.extend({}, theme.Product.prototype, {
        onResetPack: function (evt) {
            evt.preventDefault();

            theme.setSessionItem('pintsSelected', null);
        },
        onAddToCartClick: function (evt) {
            debugger;
            ensureQueue();
            this.state.queue = theme.getSessionItem('pintsSelected');
            evt.preventDefault();

            var $message = ($('<div>', {class: 'form-message form-message--success m-top-3'}));
            var $form = $(evt.currentTarget).closest('form');

            $('.form-message').remove();
            $message.text('Added!');
            $form.after($message);

            // Do nothing if limits has been reached
            if (this.onQueueLimitReached()) {
                return;
            }

            this.fillAvailableSlot();

            if (this.onQueueLimitReached()) {
                var product = this.pintsBundleProductJson;
                var items = this.getFilledSlots();
                var props = {};

                for (var i = 0; i < items.length; i++) {
                    var item = items[i];
                    props['Flavor-' + i] = item.title;
                }

                var data = {
                    id: product.variants[0].id,
                    quantity: 1,
                    properties: props
                };

                ShopifyAPI.addItem(data, this.addItemCallback.bind(this), this.addItemErrorCallback.bind(this));
            } else {

                // There are still slots remaining, return to collection page
                window.location = '/collections/pick-your-pints';
            }

        },

        /**
         * Checks if queue limit has been reached
         * @return {boolean} - Returns true if all slots are filled
         */
        onQueueLimitReached: function () {
            var slotsFilled = this.getFilledSlots();

            return slotsFilled.length >= this.packSize
                ? true
                : false;
        },

        /**
         * Returns an array of filled slots
         * @return {array} - Filtered array of filled slots
         */
        getFilledSlots: function () {
            var slotsFilled = this.state.queue.filter(function (item) {
                return item.slotFilled === true;
            });

            return slotsFilled;
        },

        fillAvailableSlot: function () {
            var product = this.productSingleObject;
            var variants = product.variants;
            var availableVariants = variants.filter(function (variant) {
                return variant.available
            });

            for (var i = 0; i < this.state.queue.length; i++) {
                var item = this.state.queue[i];

                if (!item.slotFilled) {
                    item.slotFilled = true;
                    item.id = availableVariants[0].id;
                    item.image = product.featured_image.replace('.jpg', '_200x200.jpg');
                    item.price = product.price;
                    item.quantity = 1;
                    item.index = i;
                    item.title = product.title;

                    theme.setSessionItem('pintsSelected', this.state.queue);
                    break;
                }
            }
        },

        /**
         * Sets default state for single slot data
         * @return {object} data - Default data
         */
        setDefaultSlotData: function () {
            var data = {
                slotFilled: false,
                id: null,
                quantity: 1,
                image: null,
                price: null,
                index: null
            };

            return data;
        },

        /**
         * Callback after item is added to cart
         * @param {number} - Index of item in queue to update
         */
        addItemCallback: function (index) {
            var resetArray = [];
            for (var i = 0; i < 5; i++) {
                resetArray.push(this.setDefaultSlotData());
            }

            theme.setSessionItem('pintsSelected', resetArray);
            window.location = '/cart';
        },

        /**
         * Callback after item error
         */
        addItemErrorCallback: function (XMLHttpRequest, textStatus) {
            console.log(XMLHttpRequest);
        },
    });

    return ProductPintSelect;
})();

/**
 * PintsBundle Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the PintsBundle template.
 *
 * @namespace product
 */

theme.PintsBundle = (function () {

    var selectors = {
        addToCart: '[data-add-to-cart]',
        resetBundle: '[data-reset-pack]',
        addToCartText: '[data-add-to-cart-text]',
        comparePrice: '[data-compare-price]',
        comparePriceText: '[data-compare-text]',
        priceWrapper: '[data-price-wrapper]',
        productPhotos: '[data-product-photos]',
        productPhoto: '[data-product-photo]',
        productForm: '[data-product-form]',
        productPrice: '[data-product-price]',
        productThumbs: '[data-product-single-thumbnail]',
        bundleItmeJson: '[data-bundle-item-json]',
        subscriptionInput: '[data-subscription-input]'
    };

    /**
     * PintsBundle section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function PintsBundle(container) {

        // Inherit product object methods and properties from Product constructor
        // theme.Product.call(this, container);

        this.$container = $(container);
        var sectionId = this.$container.attr('data-section-id');

        this.state = {
            queue: [],
            subscriptionEnabled: true,
            isAdding: false
        };
        this.namespace = '.product';

        // Selectors
        this.$productPhotos = $(selectors.productPhotos, this.$container);
        this.$productThumbs = $(selectors.productThumbs, this.$container);
        this.$addToCart = $(selectors.addToCart, this.$container);
        this.$resetPack = $(selectors.resetBundle, this.$container);
        this.$addToCartText = $(selectors.addToCartText, this.$container);
        this.$bundleItemJson = $(selectors.bundleItmeJson, this.$container);
        this.$subscriptionInput = $(selectors.subscriptionInput, this.$container);

        // Events
        this.$productThumbs.on('click' + this.namespace, this.updateProductImage.bind(this));
        this.$addToCart.on('click' + this.namespace, this.submitAllProducts.bind(this));
        this.$resetPack.on('click' + this.namespace, this.resetAllProducts.bind(this));
        this.$subscriptionInput.on('change' + this.namespace, this.updateSubscriptionType.bind(this));

        // Run on pageload
        if (this.$productThumbs.length) {
            this.initPhotosSlider();
        }
    }

    // Inherit prototype methods from Product.js
    PintsBundle.prototype = $.extend({}, theme.Product.prototype, {

        /**
         * Updates all items' subscription type
         */
        updateSubscriptionType: function (evt) {
            if (this.state.isAdding) {
                return;
            }

            var $el = $(evt.currentTarget);
            var value = $el.val();

            this.state.subscriptionEnabled = value === 'subscription' ? true : false;
        },

        resetAllProducts: function (evt) {

        },
        /**
         * Submits all products in queue
         */
        submitAllProducts: function (evt) {
            evt.preventDefault();
            debugger;

            if (this.state.isAdding) {
                return;
            }

            var $el = $(evt.currentTarget);

            // Set loading state
            $el.addClass('is-adding');

            // Clear any errors
            if ($('.errors', this.$container).length) {
                $('.errors', this.$container).remove();
            }

            this.buildQueueData();
            this.processItemInQueue();

            this.state.isAdding = true;
        },

        buildQueueData: function () {
            var self = this;

            this.$bundleItemJson.each(function (index, el) {
                var itemJson = JSON.parse($(el).html());
                self.state.queue.push(itemJson);
            });
        },

        processItemInQueue: function () {
            debugger;
            if (this.state.queue.length) {
                var item = this.state.queue.shift();
                this.addItemToCart(item);
            } else {
                this.$addToCart.removeClass('is-adding');
                this.state.isAdding = false;
                ajaxCart.load();
            }
        },

        /**
         * Add product via Ajax
         *
         * @param {object} item - Contains item data
         */
        addItemToCart: function (item) {
            debugger;
            var data = {
                id: item.id,
                quantity: item.quantity,
                properties: this.state.subscriptionEnabled ? item.subscriptionProperties : ''
            };

            ShopifyAPI.addItem(data, this.addItemCallback.bind(this), this.addItemCallErrorCallback.bind(this));
        },

        addItemCallback: function () {
            this.processItemInQueue();
        },

        addItemCallErrorCallback: function (XMLHttpRequest, textStatus) {
            var data = XMLHttpRequest.responseJSON;

            if (data.status === 422) {
                $(selectors.productForm, this.$container).append('<div class="errors qty-error">' + data.description + '</div>');
                console.log(data, textStatus);
            }

            this.processItemInQueue();
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function () {
            this.$container.off(this.namespace);
        }
    });

    return PintsBundle;
})();

const ensureQueue = function (size) {

    var data = sessionStorage.getItem('pintsSelected');
    var selectedPints = data ? JSON.parse(data) : [];

    size = size || selectedPints.length || 5;
    for (var i = selectedPints.length; i < size; i++) {
        var pintsDataArray = [];
        var pintDefaultData = {
            slotFilled: false,
            id: null,
            quantity: 1,
            image: null,
            price: null,
            index: null
        };
        selectedPints.push(pintDefaultData);
    }

    selectedPints = selectedPints.slice(0, size);

    sessionStorage.setItem('pintsSelected', JSON.stringify(selectedPints));
    return selectedPints.length;
}

/**
 * ShopCollection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Collection.Shop template.
 *
 * @namespace shopCollection
 */

theme.ShopCollection = (function () {

    var selectors = {
        pintsBundleProductJson: '[data-pints-bundle-product-json]',
        collectionHeader: '[data-collection-header]',
        slotsTemplate: '#SlotsTemplate',
        slotsContainer: '#SlotsContainer',
        stepWrapper: '[data-step-wrapper]',
        productCard: '[data-product-card]',
        addToOrder: '[data-add-to-order]',
        resetPack: '[data-reset-pack]',
        addToCart: '.add-to-cart',
        addToCartText: '[data-add-to-cart-text]',
        quantity: '[data-quantity]',
        slot: '[data-slot]',
        slotImage: '[data-slot-image]',
        slotRemove: '[data-slot-remove]',
        quantityBtn: '.js-qty__adjust, .js-qty__num',
        quantityPlusBtn: '.js-qty__adjust.js-qty__adjust--plus, .js-qty__num',
        packSize: '[name="variant"]'

    };

    /**
     * ShopCollection section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function ShopCollection(container) {
        this.$container = $(container);
        var sectionId = this.$container.attr('data-section-id');

        // Settings
        this.namespace = '.shopCollection';
        this.pintsBundleProductJson = JSON.parse($(selectors.pintsBundleProductJson, this.$container).html());
        this.settings = {};
        this.state = {
            currentStep: 1,
            queue: [],
            isUpdating: false
        };

        // Selectors
        this.$slotsTemplate = $(selectors.slotsTemplate, this.$container);
        this.$slotsContainer = $(selectors.slotsContainer, this.$container);
        this.$slot = $(selectors.slot, this.$container);
        this.$productCard = $(selectors.productCard, this.$container);
        this.$addToOrder = $(selectors.addToOrder, this.$container);
        this.$addToCart = $(selectors.addToCart, this.$container);
        this.$resetPack = $(selectors.resetPack, this.$container);
        this.$addToCartText = $(selectors.addToCartText, this.$container);
        this.$qty = $(selectors.quantity, this.$container);


        // Events
        this.$addToOrder.on('click' + this.namespace, this.onAddProductToQueue.bind(this));
        this.$resetPack.on('click' + this.namespace, this.onResetPack.bind(this));
        this.$addToCart.on('click' + this.namespace, this.processItemsInQueue.bind(this));
        this.$container.on('click', selectors.slotRemove, this.onRemoveProductFromQueue.bind(this));
        this.$productCard.on('change', selectors.qty, this.updateItemQuantity.bind(this));

        var $headerCt = $('[data-section-type="shop-collection"]')
        $(window).on('scroll', function (e) {
            var top = $headerCt.offset().top;

            $('.header-ct').toggleClass('collapsed', top < window.pageYOffset);

        })
        //this.$container.on('change', selectors.packSize, this.updatePackSize.bind(this));

        // Run on pageload

        var vid = null;
        var param = window.location.search.match(/\?variant\=(\d+)/);
        if (param && param.length == 2) {
            vid = parseInt(param[1]);
        } else {
            vid = this.pintsBundleProductJson.variants[0].id;
        }

        var variant = this.pintsBundleProductJson.variants.find(x => x.id == vid);
        $(`input[name="variant"][data-size="${variant.option1}"]`).click();
        // $(`input[name="variant"]:not([data-size="${variant.option1}"])`).removeAttr('checked');

        this.updatePackSize(6);


        //this.buildSlotItems();

        //new theme.StickyElement(selectors.collectionHeader,55);
    }

    ShopCollection.prototype = $.extend({}, ShopCollection.prototype, {
        /**
         * Set up initial state of slot items for page load
         */
        buildInitialQueueData: function () {
            var selectedPints = theme.getSessionItem('pintsSelected');
            this.state.queue = selectedPints;

            for (var i = 0; i < selectedPints.length; i++) {
                var pint = selectedPints[i];

                if (pint) {
                    this.updateProductCardState(pint.id);
                }
            }

            // Update state if limit has been reached
            this.updateState();
            // if (this.onQueueLimitReached()) {
            //   this.updateCurrentStep(2);
            //   $(selectors.quantityBtn).add(this.$addToOrder).prop('disabled', true);
            // }
        },
        rebuildSlots() {
            this.updatePackSize(this.packSize);
        },
        updatePackSize(evt) {
            if (typeof evt == 'object') {
                this.packSize = parseInt($(evt.currentTarget).attr('data-size'));
            } else {
                this.packSize = evt;
            }

            var variant_id = $('input[name="variant"]:checked').val();

            var variant = this.pintsBundleProductJson.variants.find(v => v.id == variant_id);

            var price = slate.Currency.formatMoney(variant.price);
            this.$addToCartText.text(price);
            this.$container.find('.pack-price').text(price);

            this.packSize = ensureQueue(this.packSize);
            $(`input[name="variant"][data-size="${this.packSize}"]`).attr('checked', 'checked');

            this.buildInitialQueueData();
            this.buildSlotItems();
        },
        /**
         * Build out each slot item in DOM
         */
        buildSlotItems: function (evt) {
            // Begin fresh

            var source = this.$slotsTemplate.html();
            var template = Handlebars.compile(source);
            var items = [];
            var data = {};

            var totalSlots = this.state.queue.length;
            // var filled = .filter(x=>x.slotFilled);
            $.each(this.state.queue, function (index, item) {

                var isAddOn = !item.slotFilled && index == totalSlots - 1;
                var to_add = {
                    slotFilled: item.slotFilled,
                    price: item.price,
                    first: index == 0,
                    last: index == totalSlots - 1,
                    id: item.id,
                    image: item.image,
                    index: index,
                    title: isAddOn ? 'Add a 6th? (+10)' : item.title,
                    is_add_on: isAddOn
                };

                items.push(to_add)
            });

            if (this.getFilledSlots() < 6) {
                // items.push({
                //   slotFilled: false,
                //   index: 5,
                //   title: 'Add a 6th! (+$10)',
                //   is_add_on: true
                // });
            }

            data = {
                items: items,
                show_add_on: items.length < 6,
                grid_item_class: ''///*this.packSize == 5 ? 'one-fifth' : */ 'one-sixth medium-down--one-quarter medium-down--push-one-quarter'
            };

            theme.setSessionItem('pintsSelected', this.state.queue);
            this.$slotsContainer.html(template(data));
        },

        onResetPack: function (evt) {

            sessionStorage.removeItem('pintsSelected');
            this.state.queue.forEach(i => {
                i.slotFilled = false;
                this.updateProductCardState(i.id);
            })
            this.updateState();
            // this.updateCurrentStep(1);
            this.rebuildSlots();
            $(selectors.addToOrder).prop('disabled', false);
        },
        /**
         * Adds a product to the queue when button is clicked
         */
        onAddProductToQueue: function (evt) {
            if (this.state.isUpdating) {
                return;
            }

            var $el = $(evt.currentTarget);
            var handle = $el.data('product-handle');
            var title = $el.data('product-title');
            var id = $el.data('id');

            // Show qty selector when ATO button is initially clicked
            this.addProductToQueue(id, handle);


        },

        /**
         * Adds a product to the queue
         * @param {number} id - Product variant's id
         * @param {string} handle - Product's handle
         */
        addProductToQueue: function (id, handle) {
            // Do not run if limit has been reached
            if (this.onQueueLimitReached()) {
                return;
            }

            this.getProductData(handle);
        },

        /**
         * Remove a product from queue when qty buttons are clicked
         */
        onRemoveProductFromQueue: function (evt) {
            if (this.state.isUpdating) {
                return;
            }

            var $el = $(evt.currentTarget);
            var index = $el.data('index');
            var id = $el.data('id');

            this.removeProductFromQueue(index, id)
        },

        /**
         * Remove a product from queue
         * @param {number} index - The product's position in the queue state
         * @param {number} id - Product's variant id
         */
        removeProductFromQueue: function (index, id) {

            // Reset
            this.state.queue[index] = this.setDefaultSlotData();
            this.buildSlotItems();

            // Update ATO button if no remaining product exist in queue
            var remainingProducts = this.state.queue.filter(function (item) {
                return item.id === id;
            });

            // Show ATO button if no more of the same product are in queue
            //if (remainingProducts.length === 0) {
            this.updateProductCardState(id);
            //}

            this.updateState();
        },

        /**
         * Sets default state for single slot data
         * @return {object} data - Default data
         */
        setDefaultSlotData: function () {
            var data = {
                slotFilled: false,
                id: null,
                quantity: 1,
                image: null,
                price: null,
                index: null
            };

            return data;
        },

        /**
         * Get product data via Ajax
         *
         * @param {string} handle - Product handle to get data from endpoint
         */
        getProductData: function (handle) {
            this.state.isUpdating = true;

            $.ajax({
                type: 'GET',
                dataType: 'json',
                url: '/products/' + handle + '.js'
            })
                .done(this.productDataCallback.bind(this))
                .fail(this.productDataErrorCallback.bind(this))
                .always(this.productDataCompleteCallback.bind(this));
        },

        /**
         * Updates product next available slot item in queue
         * @param {object} data - Product data object from Ajax
         */
        productDataCallback: function (data) {

            var product = data;
            for (var i = 0; i < this.state.queue.length; i++) {
                var item = this.state.queue[i];

                // Update queue with next available slot
                if (!item.slotFilled) {
                    var availableVariants = product.variants.filter(function (variant) {
                        return variant.available;
                    });

                    item.slotFilled = true;
                    item.id = availableVariants[0].id;
                    item.image = product.featured_image.replace('.jpg', '_200x200.jpg');
                    item.price = product.price;
                    item.quantity = 1;
                    item.index = i;
                    item.title = product.title;

                    this.updateProductCardState(item.id);
                    break;
                }
            }

            this.buildSlotItems();
        },

        /**
         * Error handler when adding to cart fails
         */
        productDataErrorCallback: function (jqXHR, textStatus, errorThrown) {
            console.log('Error', textStatus);
        },

        updateState: function () {

            var slots = this.getFilledSlots();
            var variant_id = $(`input[name="variant"][data-size="${Math.max(slots.length, 5)}"]`).val();
            if (slots.length > 4) {
                $(selectors.quantityPlusBtn).prop('disabled', this.onQueueLimitReached());
                $(selectors.addToOrder).prop('disabled', this.onQueueLimitReached())
                $('.add-to-cart').addClass('shown');
            } else {
                $(selectors.quantityPlusBtn).prop('disabled', false);
                $(selectors.addToOrder).prop('disabled', false)
                $('.add-to-cart').removeClass('shown');
            }
            var variant = this.pintsBundleProductJson.variants.find(x => x.id == variant_id);
            var price = slate.Currency.formatMoney(variant.price);
            this.$addToCartText.text(price);
            this.$container.find('.pack-price').text(price);
            //toggleClass('shown',step == 2);


            // switch (step) {
            //   case 2:
            //     this.state.currentStep = 2;
            //     $(selectors.stepWrapper + '[data-step="' + 2 + '"]').removeClass('hide');
            //     break;
            //   default:
            //     this.state.currentStep = 1;
            //     $(selectors.stepWrapper + '[data-step="' + 1 + '"]').removeClass('hide');
            // }

            // if (this.onQueueLimitReached()) {
            //   this.updateCurrentStep(2);

            // }else {
            //   if (this.getFilledSlots().length > 4) {
            //     this.updateCurrentStep(2);
            //   } else {
            //     this.updateCurrentStep(1);
            //   }
            //   $(selectors.quantityBtn).prop('disabled', false);
            // }
        },
        /**
         * When product data retrieval is done
         */
        productDataCompleteCallback: function (jqXHR, textStatus) {
            this.state.isUpdating = false;

            this.updateState();
            // Update state once limit has been reached

        },

        /**
         * Checks if queue limit has been reached
         * @return {boolean} - Returns true if all slots are filled
         */
        onQueueLimitReached: function () {
            var slotsFilled = this.getFilledSlots();

            return slotsFilled.length >= 6
                ? true
                : false;
        },

        /**
         * Returns an array of filled slots
         * @return {array} - Filtered array of filled slots
         */
        getFilledSlots: function () {
            var slotsFilled = this.state.queue.filter(function (item) {
                return item.slotFilled === true;
            });

            return slotsFilled;
        },

        /**
         * Updates the current step
         * @param {number} step - The state of the current step
         */
        updateCurrentStep: function (step) {
            //$('.add-to-cart').toggleClass('shown',step == 2);

            // $(selectors.stepWrapper, this.$container).addClass('hide');
            // switch (step) {
            //   case 2:
            //     this.state.currentStep = 2;
            //     $(selectors.stepWrapper + '[data-step="' + 2 + '"]').removeClass('hide');
            //     break;
            //   default:
            //     this.state.currentStep = 1;
            //     $(selectors.stepWrapper + '[data-step="' + 1 + '"]').removeClass('hide');
            // }
        },

        /**
         * Submits the bundle-product along with the 5 line-item properties
         */
        processItemsInQueue: function () {

            var packNo = 1;

            while (true) {
                var exists = window.cart.items.some((i) => i.sku.indexOf('IC-PIK') > -1 && parseInt(i.properties['Pack #']) == packNo);
                if (!exists) {
                    break;
                }
                packNo++;
            }

            var product = this.pintsBundleProductJson;
            var items = this.getFilledSlots();
            var props = {};


            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                props['Flavor-' + (parseFloat(i) + 1)] = item.title;
            }
            props['Pack #'] = packNo;
            var variant = $(`input[name="variant"][data-size="${items.length}"]`).val();
            var data = {
                id: variant,
                quantity: 1,
                properties: props
            };

            var uniq = items.reduce((memo, i) => {
                if (memo[i.id]) {
                    memo[i.id].quantity += i.quantity
                } else {
                    memo[i.id] = i
                }
                return memo;
            }, {});

            var add_items = Object.keys(uniq).map(k => {
                var i = uniq[k];
                return {
                    id: i.id,
                    quantity: i.quantity,
                    properties: {
                        "Pack #": packNo
                        // _parent: pack_item.key,
                        // _baseQty: i.quantity
                    }
                }
            });

            add_items.push(data);
            ShopifyAPI.addItems(add_items, function (cart) {
                window.ajaxCart.load();
                this.onResetPack()
            }.bind(this));

            // ShopifyAPI.addItem(data, function(pack_item) {
            //
            //   window.ajaxCart.load();
            // }.bind(this), this.addItemErrorCallback.bind(this));

            // ShopifyAPI.addItems([data], function() {
            //
            //   this.addItemCallback.bind(this)
            // }.bind(this), this.addItemErrorCallback.bind(this));
        },

        /**
         * Adds a single item to cart
         * @param {object} item - Product data object
         * @param {number} index - Number of item in queue to process
         */
        processAddToCart: function (item, index) {
            var self = this;
            var data = {
                id: item.id,
                quantity: item.quantity,
                properties: item.properties
            };

            ShopifyAPI.addItem(data, this.addItemCallback.bind(this, index), this.addItemErrorCallback.bind(this));
        },

        /**
         * Callback after item is added to cart
         * @param {number} - Index of item in queue to update
         */
        addItemCallback: function (index) {
            var resetArray = [];
            for (var i = 0; i < 5; i++) {
                resetArray.push(this.setDefaultSlotData());
            }

            theme.setSessionItem('pintsSelected', resetArray);
            window.location = '/cart';
        },

        /**
         * Callback after item error
         */
        addItemErrorCallback: function (XMLHttpRequest, textStatus) {
            console.log(XMLHttpRequest);
        },


        /**
         * Updates the quantity of an item in queue
         */
        updateItemQuantity: function (evt) {
            //$(selectors.quantityBtn).prop('disabled', true);

            if (this.state.isUpdating) {
                return;
            }

            var $el = $(evt.target);
            var id = $el.data('id');
            var handle = $el.data('product-handle');
            var qty = $el.val();
            var validQty = parseFloat(qty) && !isNaN(qty) ? parseFloat(qty) : 1;

            var existingProducts = this.state.queue.filter(function (item) {
                return item.id === id;
            });

            // Add or subtract item from queue
            if (validQty > existingProducts.length) {
                this.addProductToQueue(id, handle);
            } else {
                var lastItem = existingProducts.length - 1;
                this.removeProductFromQueue(existingProducts[lastItem].index, id)
                $(selectors.quantityBtn).prop('disabled', false);
            }
        },

        /**
         * Update product-card's CSS state
         * @param {number} id - Identify which product card to update based on variant id
         */
        updateProductCardState: function (id) {
            var $productCard = $(selectors.productCard + '[data-id="' + id + '"]');

            if (!$productCard.length) {
                return;
            }

            var inqueue = this.state.queue.reduce(function (memo, item) {
                return item.id === id && item.slotFilled ? memo + item.quantity : memo;
            }, 0);

            $productCard.toggleClass('is-selected', inqueue > 0);
            $productCard.find(selectors.addToOrder).prop('disabled', inqueue > 0);
            if (inqueue > 0) {
                $productCard.find('input[name="quantity"]').val(inqueue);
            }
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function () {
            this.$container.off(this.namespace);
        }
    });

    return ShopCollection;
})();

// Save initial data for "Choose Your Pints" - src/scripts/sections/shop-collection.js
$(document).ready(function () {


});

/**
 * Slideshow Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace slideshow
 */

theme.Slideshow = (function () {
    var selectors = {
        slideshow: '[data-slideshow]'
    };

    /**
     * Slideshow Section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function Slideshow(container) {
        var $container = this.$container = $(container);
        var sectionId = this.sectionId = $container.attr('data-section-id');

        if (!$(selectors.slideshow, this.$container).length) {
            return;
        }

        // Settings
        this.namespace = ".slideshow";

        // Selectors
        this.$slideshow = $(selectors.slideshow, this.$container);

        // Run on page load
        this.initSlideshow();
    }

    Slideshow.prototype = $.extend({}, Slideshow.prototype, {
        initSlideshow: function () {
            var options = {
                rows: 0,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: this.$slideshow.data('dots'),
                autoplay: this.$slideshow.data('autoplay'),
                autoplaySpeed: this.$slideshow.data('speed'),
                fade: true
            };

            this.$slideshow.slick(options);
        },

        onBlockSelect: function (evt) {
            var blockId = evt.detail.blockId;
            var $slide = $('.slideshow__slide-' + blockId + ':not(.slick-cloned)');
            var slideIndex = $slide.data('slick-index');

            // go to selected slide and pause slideshow
            this.$slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
        },

        onBlockDeselect: function () {
            // resume autoplay
            this.$slideshow.slick('slickPlay');
        }
    });

    return Slideshow;
})();

/**
 * Menu Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace menu
 */

theme.Menu = (function () {
    var selectors = {
        trigger: '.menu-detail-trigger',
        details: '.menu-content'
    };

    function Menu(container) {
        var $container = this.$container = $(container);
        var sectionId = this.sectionId = $container.attr('data-section-id');

        // Settings
        this.namespace = ".menu-page";

        // Selectors
        this.$menu = $(selectors.menu, this.$container);
        this.$trigger = $(selectors.trigger, this.$container);
        this.$details = $(selectors.details, this.$container);
        // Event Listeners
        this.$trigger.on('click' + this.namespace, this.toggleDescription.bind(this));
    }

    Menu.prototype = $.extend({}, Menu.prototype, {
        toggleDescription: function (evt) {
            var $trigger = $(evt.currentTarget);
            var $details = $trigger.siblings(this.$details);
            var $isActive = $details.hasClass('active');
            if ($isActive) {
                $trigger.removeClass('active');
                $details.removeClass('active');
            } else {
                $trigger.addClass('active');
                $details.addClass('active');
            }
        }
    });

    return Menu;
})();

/**
 * RelatedProducts Section Script
 * Shopify Plus Only - https://help.shopify.com/en/themes/development/recommended-products
 * ------------------------------------------------------------------------------
 *
 * @namespace relatedProducts
 */

theme.RelatedProducts = (function () {

    var selectors = {
        sectionSettingsJson: '[data-settings-json]',
        template: '#RelatedProductsTemplate-',
        relatedProductsContainer: '#RelatedProducts-'
    };

    // These product ids should not show in final results
    var productsToExclude = [4376093032553, 4289399947369, 39610322911337];
    var tagsToExclude = ['hide-from-recommendations'];

    /**
     * RelatedProducts section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function RelatedProducts(container) {
        this.$container = $(container);

        var sectionId = this.sectionId = this.$container.attr('data-section-id');
        var sectionSettings = JSON.parse($(selectors.sectionSettingsJson, this.$container).html());

        this.settings = sectionSettings;
        this.namespace = '.relatedProducts';

        // Selectors
        this.$shopifySection = $('#shopify-section-' + this.sectionId);
        this.$template = $(selectors.template + sectionId, this.$container);
        this.$relatedProductsContainer = $(selectors.relatedProductsContainer + sectionId, this.$container);

        this.getProducts();
    }

    RelatedProducts.prototype = $.extend({}, RelatedProducts.prototype, {

        /**
         * Go get products via ajax
         */
        getProducts: function () {
            // Add 1 to limit to create a buffer in case excluded product is returned
            var adjustedLimit = this.settings.limit + productsToExclude.length;
            var url = "/recommendations/products.json?product_id=" + this.settings.id + "&limit=" + adjustedLimit;
            var self = this;

            $.ajax({
                type: 'GET',
                url: url,
                dataType: 'json'
            })
                .done(this.getProductsSuccess.bind(this))
                .fail(this.getProductsError.bind(this));
        },

        /**
         * Build product cards with Handlebars
         *
         * @param {object} results - Data sent back from Shopify
         * @param {array} results.products - Array of related products
         */
        getProductsSuccess: function (results) {
            if (results.products.length === 0) {
                return;
            }

            var products = results.products;
            var data = {};
            var item = {};
            var items = [];
            var source = this.$template.html();
            var template = Handlebars.compile(source);

            // Build items array
            $.each(products, function (index, product) {
                if (productsToExclude.includes(product.id)) {
                    return;
                }

                if (tagsToExclude.some(x => product.tags.indexOf(x) > -1)) {
                    return;
                }
                item = {
                    available: product.available,
                    url: product.url,
                    title: product.title,
                    image: product.featured_image.replace('.jpg', '_200x200.jpg'),
                    price: slate.Currency.formatMoney(product.price),
                };

                items.push(item);
            });

            if (items.length > this.settings.limit) {
                items.length = this.settings.limit
            }

            data = {
                gridItemClasses: this.settings.gridItemClasses,
                items: items
            };

            // Show section and load products
            this.$shopifySection.removeClass('hide');
            this.$relatedProductsContainer.append(template(data));
        },

        /**
         * Log any errors
         */
        getProductsError: function (jqXHR, textStatus, errorThrown) {
            console.log(textStatus + ': ' + errorThrown);
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function () {
            this.$container.off(this.namespace);
        }
    });

    return RelatedProducts;
})();

/**
 * Image with Text Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace imageWithText
 */

theme.ImageWithText = (function () {
    var selectors = {
        slider: '.image-slider',
    };

    function ImageWithText(container) {
        var $container = this.$container = $(container);
        var sectionId = this.sectionId = $container.attr('data-section-id');

        // Selectors
        this.$slider = $(selectors.slider, this.$container);

        // Event Listeners

        // Run On load
        this.sliderInit();

    }

    ImageWithText.prototype = $.extend({}, ImageWithText.prototype, {
        sliderInit: function (evt) {
            var $slider = this.$slider;
            var options = {
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: $('.icon-chevron-left', this.$container),
                nextArrow: $('.icon-chevron-right', this.$container),
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true,
                            centerPadding: '40px',
                        }
                    }
                ]
            };
            if ($slider.length) {
                $slider.slick(options)
            }
        }
    });

    return ImageWithText;
})();

/**
 * Blog Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace blogSection
 */

theme.BlogSection = (function () {
    var selectors = {
        blogSection: '[data-blog-section]',
        blogSlider: '.blog-mobile-slider'
    };

    function BlogSection(container) {
        var $container = this.$container = $(container);
        var sectionId = this.sectionId = $container.attr('data-section-id');
        var breakpoint = window.matchMedia('screen and (max-width: 787px)');

        // Settings
        this.namespace = ".blogSection";

        // Selectors
        this.$blogSlider = $(selectors.blogSlider, this.$container);

        // Event Handlers
        if (breakpoint.matches) {
            this.initSlideshow();
        }

        breakpoint.addListener(function (bp) {
            if (bp.matches) {
                this.initSlideshow()
            } else {
                this.destroySlideshow();
            }
        }.bind(this))

    }

    BlogSection.prototype = $.extend({}, BlogSection.prototype, {

        initSlideshow: function () {
            var options = {
                rows: 0,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                fade: true
            };

            if (this.$blogSlider.length) {
                this.$blogSlider.slick(options);
            }
        },

        destroySlideshow: function () {
            this.$blogSlider.slick('unslick');
        }
    });

    return BlogSection;
})();

/**
 * Quote Slider Script
 * ------------------------------------------------------------------------------
 *
 * @namespace quoteSlider
 */

theme.QuoteSlider = (function () {
    var selectors = {
        quoteSlider: '[data-quote-slider]'
    };

    function QuoteSlider(container) {
        var $container = this.$container = $(container);
        var sectionId = this.sectionId = $container.attr('data-section-id');

        // Settings
        this.namespace = ".quoteSlider";

        // Selectors
        this.$quoteSlider = $(selectors.quoteSlider, this.$container);

        // On Load
        this.initSlideshow();

    }

    QuoteSlider.prototype = $.extend({}, QuoteSlider.prototype, {

        initSlideshow: function () {
            var options = {
                rows: 0,
                slidesToShow: 1,
                slidesToScroll: 1,
                nextArrow: $('.quote-next', this.container),
                prevArrow: $('.quote-prev', this.container),
                dots: false,
                responsive: [
                    {
                        breakpoint: 787,
                        settings: {
                            autoplay: true,
                            autoplaySpeed: 5000,
                        }
                    }
                ]
            };

            if (this.$quoteSlider.length) {
                this.$quoteSlider.slick(options);
            }
        }

    });

    return QuoteSlider;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
        return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
        new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
            hideElement: 'AddressProvinceContainerNew'
        });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function () {
        var formId = $(this).data('form-id');
        var countrySelector = 'AddressCountry_' + formId;
        var provinceSelector = 'AddressProvince_' + formId;
        var containerSelector = 'AddressProvinceContainer_' + formId;

        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
            hideElement: containerSelector
        });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function () {
        $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function () {
        var formId = $(this).data('form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function () {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
        }
    });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {
    var config = {
        recoverPasswordForm: '#RecoverPassword',
        hideRecoverPasswordLink: '#HideRecoverPasswordLink'
    };

    if (!$(config.recoverPasswordForm).length) {
        return;
    }

    checkUrlHash();
    resetPasswordSuccess();

    $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
    $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

    function onShowHidePasswordForm(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
    }

    function checkUrlHash() {
        var hash = window.location.hash;

        // Allow deep linking to recover password form
        if (hash === '#recover') {
            toggleRecoverPasswordForm();
        }
    }

    /**
     *  Show/Hide recover password form
     */
    function toggleRecoverPasswordForm() {
        $('#RecoverPasswordForm').toggleClass('hide');
        $('#CustomerLoginForm').toggleClass('hide');
    }

    /**
     *  Show reset password success message
     */
    function resetPasswordSuccess() {
        var $formState = $('.reset-password-success');

        // check if reset password form was successfully submited.
        if (!$formState.length) {
            return;
        }

        // show success message
        $('#ResetSuccess').removeClass('hide');
    }
})();

/**
 * Cart Page Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart page
 * template.
 *
 * @namespace cartPage
 */

theme.cartPage = (function () {
    if (!$('body').hasClass('template-cart')) {
        return;
    }

    var selectors = {
        qtyWrapper: '.cart_item-qty-wrapper',
        qtyInput: '.js-qty__num',
        qtyAdjust: '.js-qty__adjust',
        updateCartBtn: '[data-update-cart]',
        removeBtns: 'a.cart_remove_item[data-key]',
        clearBtn: 'a.clear-cart'
    };

    var namespace = '.cartPage'
    var cache = {};

    function init() {
        cacheSelectors();

        // Bind Events
        cache.$qtyWrapper.on('change', selectors.qtyInput, (event) => {
            return getCartJSON().then((cart) => {
                updateQuantity(event, cart);
            });
        });

        cache.$removeBtns.on('click', function (e) {
            e.preventDefault();
            // edited by Plus FED to retrieve cart object first
            return getCartJSON().then((cart) => {
                const key = e.currentTarget.dataset.key;
                removeItem(key, cart);
            });
        });

        cache.$clearBtn.on('click', clearAll);
    }

    function cacheSelectors() {
        cache = {
            $qtyWrapper: $(selectors.qtyWrapper),
            $updateCartBtn: $(selectors.updateCartBtn),
            $removeBtns: $(selectors.removeBtns),
            $clearBtn: $(selectors.clearBtn)
        };
    }

    function getCartJSON() {
        return fetch('/cart.js')
            .then(function (response) {
                return response.json();
            })
    }

    function clearAll() {

        var params = {
            type: 'POST',
            url: '/cart/clear.js',
            dataType: 'json',
            success: function (cart) {
                location.reload();
            }
        };

        return jQuery.ajax(params);
    }

    function removeItem(key, cart_data) {
        window.cart = cart_data;
        var inx = cart_data.items.findIndex(x => x.key == key);
        return ShopifyAPI.changeItem(inx + 1, 0, function (cart) {
            location.reload();
        });
    }

    function updateQuantity(evt, cart_data) {
        window.cart = cart_data;
        var $el = $(evt.currentTarget);
        var key = evt.currentTarget.id.replace('updates_', '');
        var inx = cart_data.items.findIndex(x => x.key == key);


        ShopifyAPI.changeItem(inx + 1, parseInt(evt.currentTarget.value), function (cart) {
            location.reload();
        });


        $(selectors.qtyInput).prop('readonly', true);
        $(selectors.qtyAdjust).prop('disabled', true);

        Shopify.updateQuantity
        // cache.$updateCartBtn.trigger('click');
    }

    // Run on page load;
    init();
})();

/**
 * Location Page Script
 * ------------------------------------------------------------------------------
 *
 * @namespace locationPage
 */

theme.locationPage = (function () {

    var selectors = {
        divisionContainer: '.division-container',
        accordionHeader: '.location-accordion__header'
    };

    var cache = {};

    function init() {
        cacheSelectors();

        // Bind Events
        cache.$divisionContainer.each(function (index, el) {
            initDivisionSlider(el)
        });
        cache.$accordionHeader.on('click', accordionToggle);
    }

    function cacheSelectors() {
        cache = {
            $divisionContainer: $(selectors.divisionContainer),
            $accordionHeader: $(selectors.accordionHeader)
        };
    }

    function accordionToggle(evt) {
        var $el = $(evt.currentTarget);
        var $accordion = $el.parent();

        if ($accordion.hasClass('active')) {
            $accordion.removeClass('active')
        } else {
            $accordion.addClass('active')
        }
    }

    function initDivisionSlider(el) {
        var $container = $(el);
        var $locationBlock = $container.parents('.location-block');
        var options = {
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: $('.division-prev', $locationBlock),
            nextArrow: $('.division-next', $locationBlock),
            responsive: [
                {
                    breakpoint: 1190,
                    settings: {
                        slidesToShow: 3
                    }
                }, {
                    breakpoint: 920,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        }

        if ($(el).children().length > 4) {
            $(el).slick(options);
            $(el).siblings('.division-prev').removeClass('hide');
            $(el).siblings('.division-next').removeClass('hide');
        }
    }

    function destroyDivisionSlider() {
        cache.$divisionContainer.slick(unslick);
    }

    // Run on page load;
    init();
})();

/**
 * About Page Script
 * ------------------------------------------------------------------------------
 *
 * @namespace aboutPage
 */

theme.aboutPage = (function () {
    if (!$('#about').length) {
        return;
    }

    var selectors = {
        topTitle: '.top-title',
        bottomTitle: '.bottom-title',
        issueContainer: '.issue-container',
        confettiCanvas: '#ConfettiCanvas'
    };

    var cache = {};

    function init() {
        cacheSelectors();
        initBreakpoints();


        // Bind Events
        cache.$topTitle.each(function (index, el) {
            initTopCurvedText(el)
        });
        cache.$bottomTitle.each(function (index, el) {
            initBottomCurvedText(el)
        });
        $(window).on('scroll', initScrollTop);
    }

    function cacheSelectors() {
        cache = {
            $topTitle: $(selectors.topTitle),
            $bottomTitle: $(selectors.bottomTitle),
            $issueContainer: $(selectors.issueContainer),
            $confettiCanvas: $(selectors.confettiCanvas)
        };
    }

    function initScrollTop() {
        var top = $(document).scrollTop();
        var main = $('.about-main-image').offset().top;
        var stop = $('.about-main-image').offset().top;

        if (top > main) {
            if ($('.confetti-canvas').hasClass('active')) {
                return
            } else {
                initConfetti();
            }
        }
    }

    function initConfetti() {
        var confettiSettings = {
            target: 'ConfettiCanvas',
            width: 350,
            height: 500,
            clock: 30,
            props: ['line', 'square'],
            colors: [[240, 210, 131], [249, 66, 58]]
        }
        var confetti = new ConfettiGenerator(confettiSettings);

        confetti.render();
        $('.confetti-canvas').addClass('active');

        setTimeout(function () {
            $('.confetti-canvas').removeClass('active');
            $(window).off();
        }, 2000);
    }

    function initTopCurvedText(el) {
        new CircleType(el).radius(140);
        $(el).css('transform', 'rotate(37deg)');
    }

    function initBottomCurvedText(el) {
        new CircleType(el)
            .dir(-1)
            .radius(140);

        $(el).css('transform', 'rotate(25deg)');
    }

    function initSlider() {
        var $slider = cache.$issueContainer,
            options = {
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false
            }

        if ($slider.hasClass('slick-initialized')) {
            return
        } else {
            $slider.slick(options);
        }
    }

    function destroySlider() {
        var $slider = cache.$issueContainer;

        $slider.slick('unslick');
    }

    function initBreakpoints() {
        const breakpoint = window.matchMedia("(max-width: 767px)");
        if (breakpoint.matches) {
            initSlider();
        }

        breakpoint.addListener(function (mq) {
            if (mq.matches) {
                initSlider();
            } else {
                destroySlider();
            }
        })
    }

    // Run on page load;
    init();
})();

(function () {
    if (!$('body').hasClass('template--timeline')) {
        return;
    }

    var svgs = document.querySelectorAll('.timeline-trial-svg')
    var options = {
        threshold: 1.0
    };
    var observer = new IntersectionObserver(callback);

    function callback(entries, observer) {
        entries.forEach(function (entry) {
            var el = entry.target;

            if (entry.isIntersecting) {
                var percentage = parseInt(entry.intersectionRatio * 100);
                // el.classList.remove('collapse');
                el.classList.add('expand');
                observer.unobserve(el);
            }
        });
    }

    svgs.forEach(function (svg) {
        observer.observe(svg);
    });
})();


$(document).ready(function () {
    var sections = new slate.Sections();
    sections.register("product", theme.Product);
    sections.register("pint-select", theme.ProductPintSelect);
    sections.register("pints-bundle", theme.PintsBundle);
    sections.register('slideshow-section', theme.Slideshow);
    sections.register('shop-collection', theme.ShopCollection);
    sections.register('menu', theme.Menu);
    sections.register('related-products', theme.RelatedProducts);
    sections.register('image-with-text', theme.ImageWithText);
    sections.register('blog-section', theme.BlogSection);
    sections.register('quote-slider', theme.QuoteSlider);

    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));

    $(".in-page-link").on("click", function (evt) {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    // Target tables to make them scrollable
    var tableSelectors = ".rte table";

    slate.rte.wrapTable({
        $tables: $(tableSelectors),
        tableWrapperClass: "rte__table-wrapper"
    });

    // Target iframes to make them responsive
    var iframeSelectors =
        '.rte iframe[src*="youtube.com/embed"],' +
        '.rte iframe[src*="player.vimeo"]';

    slate.rte.wrapIframe({
        $iframes: $(iframeSelectors),
        iframeWrapperClass: "rte__video-wrapper"
    });

    // Apply a specific class to the html element for browser support of cookies.
    if (slate.cart.cookiesEnabled()) {
        document.documentElement.className = document.documentElement.className.replace(
            "supports-no-cookies",
            "supports-cookies"
        );
    }

    // init mobile drawers
    theme.MobileNav.init();

    // init accordions
    var disclosure = new Houdini('[data-houdini-group]', {
        isAccordion: true
    });
});

// $(document).on('lazybeforesizes', function(e){
//   
// });

